import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import {Alert, Box, Card, CardContent, Checkbox, Divider, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Helmet } from 'react-helmet-async';
import { Icon as Iconify } from '@iconify/react';
import CloseIcon from '@mui/icons-material/Close';
import LoadingProgressBar from "../../components/loading-progressbar/loadingprogressbar";
import DistributorClaimApprovalHeader from "./DistributorClaimApprovalHeader";
import DistributorClaimApprovalMainHeader from './DistributorClaimApprovalMainHeader'
import Main from "./DistributorClaimMainLayout";
import Footer from "../../layouts/main/Footer";
import DistributorClaimApprovalService from "./DistributorClaimApprovalService";
import PopUpHandle from "../../commons/PopUpHandle";




const DistributorClaimApproval = () => {
    const [loading1, setLoading1] = useState(true);
    const [loading, setLoading] = useState(false);
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);
    const navigate = useNavigate();

    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);


    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }
    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const dynamicId = sessionStorage.getItem('id');
    const token = localStorage.getItem('_UserToken'); // Adjust the storage method as needed


    useEffect(() => {
        if (!token) {
            navigate('/login'); // Redirect to login if token is absent            
        } else {
            setLoading1(false); // Allow rendering if the token is present
        }
    }, [navigate, token]);

    useEffect(() => {



        const fetchData = async () => {
            setLoading(true);
            try {
                const DistributorClaimApprovalServiceInstance = await DistributorClaimApprovalService;
            // NOSONAR   const response = await DistributorClaimApprovalServiceInstance.GetStatusOfDistributorClaimApproval(dynamicId);
                // eslint-disable-next-line no-unused-vars
                const response = await DistributorClaimApprovalServiceInstance.ContractClaimApproval(dynamicId); // NOSONAR
                // DO NOT REMOVE THIS.. IMPORTANT
               

            } catch (err) {     

                const errorMessage = err?.response?.data?.error?.message;
                const errorrCode = err?.response?.data?.error?.code;

                if (errorMessage) { // Check if message is not empty
                    setErrorCode(errorrCode);
                    setError(errorMessage);
                    setOpen(true);

                }
                if (errorMessage === "Claim already submitted.") {
                    setClicked(true);
                } 

                        
                
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [dynamicId]);


    const handleCheckboxChange = async (event) => {
        if (error === "Claim already submitted.") { // NOSONAR
            return;
        }
        // NOSONAR if (error) return;
        if (checkboxChecked) return;

        const isChecked = event.target.checked; // Check the current state of the checkbox

        // Update the state immediately only if it is being checked
        if (!isChecked) return;
        setLoading(true);
        try {
            const payload = {
                MailApprovalMasterId: dynamicId
            }
            const DistributorClaimApprovalServiceInstance = await DistributorClaimApprovalService;
            const response = await DistributorClaimApprovalServiceInstance.GetStatusOfPODDocuments(payload);

            if (response.status === 200) {              
                setCheckboxChecked(true);
            } else {
                setCheckboxChecked(false);
                setErrorCode(response.status);
                setError(response?.data?.error?.message || 'An error occurred');
                setOpen(true);
            }
        } catch (err) {
            setCheckboxChecked(false);
            if (err.response && err.response.status === 404 || err.response.status) {
                const errorMessage = err.response?.data?.error?.message || 'An unknown error occurred';
                setErrorCode(err.response.status);
                setError(errorMessage);
                setOpen(true);
            } else {
                setErrorCode(err?.response?.status || 'Unknown Error');
                setError(err.response?.data?.error?.messag);
                setOpen(true);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleApproval = async (isApproved) => {
        if (clicked) return; // Return early if a button has already been clicked
        setClicked(true); // Set the clicked state to true
        setLoading(true);
        try {
            const payload = {
                MailApprovalMasterId: dynamicId,
                UserId: 0,
                IsApproved: isApproved
            };

            const DistributorClaimApprovalServiceInstance = await DistributorClaimApprovalService;
            const response = await DistributorClaimApprovalServiceInstance.DistributorClaimApprovalButtons(payload);
            if (response.status === 200) {
                displayAlert('success', response.data.Message, true);
                setTimeout(() => {
                    hideAlert();
                }, 2000);
            } 

        } catch (err) {
           
                setErrorCode(err.response.status);
                setError(err?.response?.data?.error?.message);
                setOpen(true);
                setClicked(false); // Reset clicked state to allow button usage
         
        } finally {
            setLoading(false);
        }
    };




    return (token && (
        <>
            <DistributorClaimApprovalMainHeader />
            <Helmet>
                <title> Distributor Claim Approval | ProClaimz </title>
            </Helmet>
            <Main>
                <Card sx={{
                    padding: '2px',
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px', // Add rounded corners
                    margin: '5px 3px 5px 3px',
                    height: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,

                }}>
                    <CardContent style={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        paddingBottom: '0.5rem',
                        minHeight: 0
                    }}>
                        <DistributorClaimApprovalHeader headerName="Distributor Claim Approval" />
                        <Divider sx={{ my: 2 }} />
                        <Box>

                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    checked={checkboxChecked}
                                    onChange={handleCheckboxChange}
                                    size='small'
                                    disabled={clicked}
                                />
                                <Typography variant="body1" sx={{ fontSize: '14px', marginLeft: '10px' }}>
                                    All the relevant documents are submitted as part of the claim. Any missing or inappropriate document will result in delay in processing the claims.
                                </Typography>

                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                    <Tooltip
                                        title="Approve"
                                        sx={{
                                            bgcolor: '#43b5a2',
                                            color: '#fff',
                                            borderRadius: '4px',
                                            height: '25px',
                                            width: '26px',
                                            marginLeft: '8px',
                                        }}
                                    >
                                        <IconButton
                                            type="button"
                                            onClick={() => {
                                                if (!checkboxChecked) {
                                                    return;
                                                }

                                                if (error !== 'Claim already submitted.') { // NOSONAR
                                                    handleApproval(true);
                                                }
                                            }}
                                            size="small"
                                            disabled={clicked}
                                        >
                                            <Iconify icon="bx:check" />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip
                                        title="Reject"
                                        sx={{
                                            bgcolor: '#ff4d4f',
                                            color: '#fff',
                                            borderRadius: '4px',
                                            height: '25px',
                                            width: '26px',
                                            padding: '4px',

                                        }}
                                    >
                                        <IconButton
                                            type="button"
                                            onClick={() => {
                                                if (error !== 'Claim already submitted.') { // NOSONAR
                                                    handleApproval(false);
                                                } 
                                            }}
                                            size="small"
                                            disabled={clicked}
                                        >
                                            <Iconify icon="bx:x" />
                                        </IconButton>
                                    </Tooltip>


                                </Box>

                            </Box>

                            <Divider sx={{ my: 2 }} />


                        </Box>
                        {loading1 && <LoadingProgressBar />}
                        {loading && <LoadingProgressBar />}
                        {open && (
                            <PopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode} />
                        )}
                        {showAlert && (
                            <Stack sx={{ height: '2em', width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                                <Alert
                                    severity={alertType}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setAlertType('');
                                                setAlertMessage('');
                                                setShowAlert(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                >
                                    {alertMessage}
                                </Alert>
                            </Stack>
                        )}

                    </CardContent>
                </ Card>
            </Main>
            <Footer />
        </>
    )
    );
};

export default DistributorClaimApproval;
